import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserContextService } from './user-context.service';

export const activateGuard: CanActivateFn = () => {
  const userContextSvc = inject(UserContextService);
  const router = inject(Router);

  return userContextSvc.getUserContext().pipe(
    map((x) => {
      if (!x) {
        router.navigate(['/403']);
        return false;
      }

      const hasAccess = (x.BusinessFunctionContexts || []).length > 0;

      if (!hasAccess) {
        router.navigate(['/403']);
        return false;
      }

      return true;
    })
  );
};
